module.exports = __webpack_public_path__ + "static/media/fondo-nuevo-home-paquetes.e238ee93.webp";